import React from 'react';
import './Footer.css';

function Footer() {
  const handleScroll = (e, targetId) => {
    e.preventDefault();
    const element = document.getElementById(targetId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>Milchkettenmusik Tonstudio</h3>
          <p>Röntgenstraße 23 a</p>
          <p>22335 Hamburg</p>
          <p>Mitglied im Verband Deutscher Tonmeister</p>
        </div>
        <div className="footer-section">
         
        </div>
        <div className="footer-section">
          <h4>Kontakt</h4>
          <p>Telefon Studio: <a href="tel:+494055890396">040 55 89 03 96</a></p>
          <p>Mobil: <a href="tel:+4915206117543">01520 611 75 43</a></p>
          <p>E-Mail: <a href="mailto:info@milchkettenmusik2.de">buchung@mkm2.de</a></p>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Milchkettenmusik Tonstudio. Alle Rechte vorbehalten.</p>
        <div className="footer-legal-links">
          <a href="/impressum.html">Impressum</a>
          <span>·</span>
          <a href="/datenschutz.html">Datenschutz</a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;

